import React from "react";
import UserEditComponent from "./UserEdit";

const UserEdit = () => {
    return <UserEditComponent />;
};

export default UserEdit;
